const translations = {
    kz: {
        logo_description: "Удобно получить займ в Казахстане",
        footer_text: " - Удобный подбор займов в Казахстане, 2020",
        sign_in_through: "Или войдите через",

        register: "Регистрация",
        enter: "Войти",
        exit: "Выйти",
        next: "Далее",
        back: "Назад",
        close: "Закрыть",
        confirm: "Подтвердить",
        save: "Сохранить",
        complite: "Завершить",
        skip: "Пропустить",

        personal_data: "Личные данные",

        step_counter: "{number} этап",

        confirm_email: "Подтвердить email",
        confirm_phone: "Подтвердить телефон",

        email_not_confirmed: "Ваш Email не подтвержден",
        phone_not_confirmed: "Ваш телефон не подтвержден",

        change_password: "Изменить пароль",
        settings_saved: "Настройки сохранены",
        password_saved: "Пароль сохранен",

        attributes: {
            phone_number: "Номер телефона",
            email: "Email",
            password: "Пароль",
            confirm_password: "подтверждение пароля",
            surname: "фамилия",
            name: "имя",
            second_name: "отчество",
            birthday: "Дата рождения",
            address: "Адрес",
            vendorConfirm: "Подтвердите согласие на обработку персональных данных",
            vendor_confirm: "Подтвердите согласие на обработку персональных данных",
            passport: "Серия и номер паспорта",
        },

        pay: {
            subscriptionConfirm:
                "Даю согласие на оформление подписки, которая стоит 6.99 USD за каждые 7 дней использования сервиса",
            commission: "подписка сервиса 6.99 USD за каждые 7 дней использования сервиса",
            account: "Аккаунт",
            card_list: "Ваши карты",
            no_card: "У вас нет привязанной банковской карты",
            add: "Добавить новую карту",
            active: "Активна",
            success: "Ваша банковская карта успешно привязана",
            notification_text:
                "Пожалуйста, добавьте данные Вашей платежной карты. Это необходимо для оценки состояния Вашего финансового здоровья и подбора персональных предложений.",

            help_text_modal:
                "Для успешной привязки используйте карты VISA или MASTERCARD. С карты спишется <b>0.1 USD </b> в счет стоимости услуги.",

            activation: "Активация аккаунта",
            help_text:
                "Для активации услуги введите данные вашей карты. Для успешной привязки используйте карты VISA или MASTERCARD. С карты спишется <b>1 единица валюты </b>   в счет стоимости услуги.",
            why: "Зачем нужно привязывать карту?",
            why_hint:
                "Это необходимо для оценки состояния Вашего финансового здоровья <br> и подбора персональных предложений.",
            more_info: "Подробнее о подписке",
            pass: "Пропустить",
            decline:
                "Платеж отменен. Попробуйте еще раз или укажите данные другой банковской карты.",
            info:
                "Внимание! {host} не является кредитной организацией. {host} предлагает ограниченный доступ с оплатой по факту использования к сравнительному программному обеспечению, чтобы упростить процесс поиска лицензированной кредитной компании. Для того чтобы получить услугу подбора кредитных продуктов, Вам нужно привязать Вашу банковскую карту (VISA, MASTERCARD, MIR) к аккаунту. На карте должен быть не нулевой баланс. Совершая платеж, Вы соглашаетесь с публичной офертой подписки и даете Ваше согласие на обработку персональных данных и получение рекламных материалов. Также Вы подтверждаете, что уведомлены о списании авторизационного платежа в счет стоимости услуги при привязке карты, о списании 6.99 USD каждые 7 дней использования сервиса, на срок пять месяцев и поручаете оператору применять рекуррентные платежи. Безопасность платежей осуществляется с помощью БАНКА-ЭКВАЙЕРА, функционирующего на основе современных протоколов и технологий, разработанных международными платежными системами VISA International и MasterCard International (3D Secure, USAF). Безопасность передаваемой информации обеспечивается с помощью современных протоколов безопасности в Интернет (SSL/TLS).",
            offer_payment_text:
                "Чтобы оставить заявку в банке, привяжите карту, на которую будут поступать деньги от банка. Для верификации карты, спишется 0.1 USD.",
            registration_help_text:
                "Мы проверили Ваши данные и подготовили список банков, которые одобрили для Вас необходимую сумму. Чтобы увидеть список банков, подтвердите номер карты, на которую в будущем будут поступать деньги от банков. Для верификации карты, спишется 0.1 USD.",
        },

        my_offers: "Мои предложения",
        profile: "Личный кабинет",
        offers: "Офферы",
        users: "Пользователи",
        deals: "Сделки",
        notification_settings: "Настройки оповещений",
        user_cabinet: "Личный кабинет",
        forgot_password: "Забыли пароль?",
        divider_or: "ИЛИ",
        personal_info: "Личная информация",

        phone_number: "Номер телефона:",
        email: "Email:",
        password: "Пароль:",
        confirm_password: "Повторите пароль:",

        errors: {
            check_correct: "Проверьте правильность заполнения!",
            phone_number_not_valid: "Проверьте правильность номера телефона",
            wrong_auth_params: "Пользователь с такими номером телефона и паролем не найден",
            wrong_login_or_password: "Неправильный логин или пароль",
            email_not_valid: "Проверьте правильность Email",
            phone_already_registered: "Пользователь с таким номером телефона уже зарегестрирован",
            email_already_registered: "Пользователь с таким Email уже зарегестрирован",
            server_error: "Ошибка сервера",
            wrong_code: "Неверный код подтверждения",
            user_not_registered: "Пользователь не прошел регистрация",
            user_not_found: "Пользователь не найден",
            cant_register: "Нам не удалось вас зарегистрировать!",
            unknown_error: "Неизвестная ошибка",
            we_cant_send_email: "Мы не можем отправить вам код подтверждения!",
        },

        page_not_found: "Страница не найдена",
        return_to_main_page: "Перейти на главную",

        password_restoration: "Восстановление пароля",
        your_email: "Email, с которым вы регистрировались:",
        code_from_mail: "Код из письма:",
        code_from_sms: "Код из СМС",
        restore_password: "Восстановить пароль",
        send_code: "Отправить код",
        send: "Отправить",
        send_again: "Отправить повторно",
        verify_later: "Подтвердить позже",
        phone_number_when_you_register: "Номер телефона с которым вы регистрировались:",
        to_proceed_enter_sms_code: "Для продолжения регистрации введите код из СМС",
        dont_get_code: "Не получили код?",
        we_send_sms_with_code: "Мы отправили вам СМС с кодом подтверждения!",
        sms_was_send_again: "Код подтверждения был отправлен повторно",
        i_need: "Мне нужно",
        choose_loan_value: "Выберите сумму займа",

        get_percent_to_approve_chance_phone_and_email:
            "Получите +{possibility}% к одобрению заявки, указав номер телефона и E-mail",
        get_percent_to_approve_chance_phone:
            "Получите +{possibility}% к одобрению заявки, подтвердив номер телефона",
        confirm_your_phone: "Для идентификации подтвердите ваш номер телефона!",
        we_will_send_code_to_phone: "Мы отправим на номер <b>{phone}</b> код в смс",
        last_step_left: "Остался последний шаг до получения лучших предложений!",
        request_for_getting_money: "ЗАЯВКА НА ПОЛУЧЕНИЕ ДЕНЕГ",
        approvement_chance: "Вероятность одобрения заявки: {loanPossibility}%",
        we_sent_mail_to_your_email_register:
            "На вашу почту <b>{email}</b> отправлено письмо для подтверждения регистрации. <br>\n" +
            "Перейдите по ссылке в письме для продолжения!",
        we_sent_mail_to_your_email_confirm:
            "На вашу почту <b>{email}</b> отправлено письмо для подтверждения Email. <br>\n" +
            "Перейдите по ссылке в письме для продолжения!",
        best_offers_for_you: "Мы подобрали для вас лучшие предложения от кредитных организаций!",
        we_sent_mail_to_you: "Мы отправили письмо на ваш Email: <br> <b>{email}</b>",
        send_SMS_to_phone: "Отправить СМС на телефон",
        SMS_was_send_to_phone: "Мы отправили СМС на ваш телефон: <br> <b>{phone}</b>",
        for_verification_plese_confirm_email:
            "Для идентификации подтвердите, пожалуйста, свой email-адрес.\n" +
            "Письмо отправлено на почту:",
        to_email: "В почту!",
        for_email_verificcation: "+25% за подтверждение почты",

        contact_info: "Контактная информация",
        phone_confirmation: "Подтверждение телефона",
        email_confirmation: "Подтверждение email",
        registration_check: "Проверка регистрации",

        sum: "Сумма: ",
        rating: "Рейтинг: ",
        loan_sum: "Сумма займа",
        up_to_x_currency: "до {sum}",
        loan_period: "Срок займа",
        up_to_x_days: "до {days} дней",
        percentage_rate: "Процентная ставка",
        from_x_percent_in_day: "от {bet}% в день",
        from_x_percent: "от {bet}%",
        get_money: "Получить деньги",
        success_rate: "Процент одобрения",
        get_more_offers_verificate_your_email:
            "Получите еще больше предложений подтвердив вашу электронную почту",
        go_to_profile: "Перейти в профиль",
        currency: "тенге",
        currency_symbol: "₸",
        days: "дней",

        name: "Имя",
        surname: "Фамилия",
        second_name: "Отчество",

        confirmed: "Подтвержден",
        not_confirmed: "Не подтвержден",

        my_applications: "Мои заявки",
        fill_the_information_and_we_can_remind_you:
            "Заполните информацию о займе и мы сможем своевременно напомнить вам!",
        maturity_date: "Дата погашения",
        payout_date: "Дата выплаты",
        correct_data: "Изменение параметров",
        status: "Статус",

        deals_status: {
            approved: "Одобрено",
            rejected: "Отклонено",
            pending: "Ожидает рассмотрения",
        },

        months: {
            jan: "Январь",
            feb: "Февраль",
            mar: "Март",
            apr: "Апрель",
            may: "Май",
            jun: "Июнь",
            jul: "Июль",
            aug: "Август",
            sep: "Сентябрь",
            oct: "Октябрь",
            nov: "Ноябрь",
            dec: "Декабрь",
        },

        days_of_the_week: {
            mon: "Пн",
            tue: "Вт",
            wed: "Ср",
            thu: "Чт",
            fri: "Пт",
            sat: "Сб",
            sun: "Вс",
        },
        first_day_of_week: "1", // понедельник
        go_to: "Перейти",
        new_application_header: "Поздравляем, вам одобрили займ",
        new_applications_body: 'Заполните информацию о займе в разделе "Мои займы"',
        no_applications: "У вас еще нет подтвержденных заявок",
        post_application: "Оставить заявку",

        get_now: "Получите деньги онлайн под <b>0%</b>, не выходя из дома",

        we_recommend_to_use_all_offers:
            "Рекомендуем оставить заявки на всех сайтах для 100% получения денег!",
        mask: {
            phone: "+7 (###) ###-##-##",
            passport: "## ########",
        },
        loan_possibility_hint: "+ {percent}% к вероятности одобрения заявки",
        mobile_phone: "Мобильный телефон",
        address: "Город рождения",
        address_description: "Адрес регистрации (полностью)",
        password_confirm: "Пароль повторно",
        password_description: "Введите Ваш пароль",
        continue: "Продолжить",
        done: "завершено",
        vendor_confirm: "Даю согласие на",
        private_data: "обработку персональных данных",
        advert_agree: "и на получение материалов рекламного характера, а также согласен с",
        public_offer: "публичной офертой и документами",

        possibility_hint: "<b>+ {percent}%</b> к одобрению за заполнение поля {field}",
        possibility_hint_vars: {
            surname: "Фамилия",
            name: "Имя",
            second_name: "Отчество",
            phone: "Номера телефона",
            email: "Email",
            birthday: "Дата рождения",
            address: "Город рождения",
            passport: "Серия и номер паспорта",
        },
        check_requisites: {
            data_analize: "Анализ введенных данных",
            checking_information:
                "Наши алгоритмы обрабатывают введенную Вами информацию. Это не займет много времени. Пожалуйста, не закрывайте страницу...",
            data_check: "Данных проверено: <b>{count}</b>",
            data_check_without_count: "данных проверено",
            step_1: "Шаг 1 из 4...",
            step_2: "Шаг 2 из 4...",
            step_3: "Шаг 3 из 4...",
            step_4: "Шаг 4 из 4...",
            check_fio: "Проверяем ФИО",
            check_date_of_birth: "Проверяем дату рождения",
            check_email: "Проверяем Email",
            check_phone: "Проверяем телефон",
            check_social: "Анализ профилей в соц. сетях",
            check_messengers: "Анализ аккаунтов в мессенджерах",
            find_personal_offers: "Подбираем персональные предложения",
            check_ended: "Спасибо за ожидание, проверка Ваших данных окончена!",
            check_done: "Проверка данных прошла успешно!",
            data_ckecking: "Проверка данных...",
            complete_percents: "Завершено {percent}%",
        },
        exception: {
            VerificationCodeAlreadySentException: "Код подтверждения уже был выслан вам на {type}",
            UserNotFoundException: "Пользователь с такими номером телефона не найден",
            UserAlreadyRegisteredException:
                "Пользователь с таким номером телефона или Email уже зарегистрирован",
        },

        credit_score: {
            score: "Кредит. рейтинг",
            best_offers: "Самые выгодные предложения с Вашим кредитным рейтингом",
            own_model: "Рейтинг рассчитан по собсвенной модели сервиса",
            change_answers: "Изменить ответы",
            find_out_rating: "Узнать кредитный рейтинг",
            get_rating: "Узнать кредитный рейтинг",
            answer_questions: "Ответьте на 5 вопросов",
            know_you_rating_for_offers:
                "Для того чтобы получить самые <b>выгодные</b> предложения узнайте кредитный рейтинг",
            calculate_score:
                "Мы рассчитаем Ваш кредитный рейтинг и подготовим персональные рекомендации",
            your_score: "Ваш кредитный рейтинг: {score}",
            score_status_hint: "что это значит?",
            info:
                "Персональный кредитный скоринг - инструмент оценки надежности заемщика кредитной организацией при принятии решения о выдаче кредита.",
            header: "Кредитный рейтинг",
            points: "баллов",
            questions: {
                q1: {
                    header: "Вы уже брали кредиты?",
                    a1: "Кредитов не было",
                    a2: "Есть действующие, еще не погашены",
                    a3: "Было погашено до 5 кредитов",
                    a4: "Было погашено до 10 кредитов",
                    a5: "Было погашено более 10 кредитов",
                },
                q2: {
                    header: "Какой у вас тип занятости?",
                    a1: "Руководитель",
                    a2: "Работник (по трудовому договору)",
                    a3: "Военослужайщий/Госслужащий",
                    a4: "Индивидуальный предприниматель",
                    a5: "Пенсионер",
                    a6: "Не трудоустроен",
                },
                q3: {
                    header: "Укажите ваш стаж на текущем месте работы",
                    a1: "Менее 3 месяцев",
                    a2: "От 3 до 6 месяцев",
                    a3: "Менее года",
                    a4: "От 1 до 3 лет",
                    a5: "Более 3 лет",
                },
                q4: {
                    header: "Укажите ваш возраст",
                    a1: "18-21 год",
                    a2: "22-25 лет",
                    a3: "26-29 лет",
                    a4: "30-35 лет",
                    a5: "36-55 лет",
                    a6: "56-60 лет",
                    a7: "более 60 лет",
                },
                q5: {
                    header: "Укажите ваш примерный доход в месяц",
                    a1: "менее 50 000 тг.",
                    a2: "100 000 тг.",
                    a3: "150 000 тг.",
                    a4: "200 000 тг.",
                    a5: "300 000 тг.",
                    a6: "более 500 000 тг.",
                },
            },
            status: {
                very_high:
                    "<b>951 - 999</b>: У Вас очень хороший кредитный рейтинг. Вероятность отказа в кредите крайне мала.",
                high:
                    "<b>896 - 950</b>: У Вас хороший кредитный рейтинг. Вы имеете хорошие шансы на получение кредита.",
                normal:
                    "<b>766 - 895</b>: У Вас средний кредитный рейтинг. Получение кредита возможно, но не гарантировано. Для 100% получения займа, рекомендуем оставить заявки во всех предложениях.",
                low:
                    "<b>596 - 765</b>: У Вас низкий кредитный рейтинг. Вероятность получения кредита мала. Для повышения вероятности одобрения займа, настоятельно рекомендуем оставить заявки во всех сайтах.",
                very_low:
                    "<b>1 - 595</b>: У Вас очень низкий кредитный рейтинг. Получить займ будет затруднительно. Чтобы повысить кредитный рейтинг и вероятность одобрения займа, пожалуйста, оставьте заявки во всех сайтах.",
            },
        },
        terms_of_use_title: "Пользовательское Соглашение",
        personal_terms_title: "Политика в отношении обработки и защиты персональных данных",
        terms_of_use:
            '<span style="font-style:normal;font-weight:400;font-size:16px;">' +
            "Перед началом использования сайта просим вас внимательно ознакомиться с настоящим документом. " +
            "Использование ресурса http://mizaem.com.kz возможно только на условиях данного Соглашения. Если Вы не принимаете " +
            "условия настоящего Соглашения в полном объеме, Вы не можете использовать сайт http://mizaem.com.kz<br /><br /><strong>1. Общие положения" +
            "</strong><br />Ресурс http://mizaem.com.kz (далее &mdash; Ресурс) не является финансовым учреждением, банком или кредитором. Это информационный " +
            "портал про МФО и кредитные сервисы России. Сайт информирует пользователей об имеющихся на рынке МФО предложениях.<br />Настоящее Пользовательское " +
            "соглашение (Далее &mdash; Соглашение) регулирует отношения между администрацией сайта http://mizaem.com.kz, именуемой далее &mdash; Администрация, " +
            "и любым лицом, посещающим (использующим) Ресурс, именуемым далее &mdash; Пользователь.<br />Настоящее Соглашение&nbsp;является офертой (далее по " +
            "тексту &mdash; Оферта, адресованной любым лицам, и может быть принято лицом не иначе как путем присоединения к Соглашению в целом.<br />Пользователь " +
            "не вправе заключить настоящее Соглашение, если не достиг возраста, достаточного для его заключения, согласно действующему законодательству.<br /><br />" +
            "<strong>2. Предмет соглашения</strong><br />2.1. Администрация Ресурса предоставляет Пользователю простую (неисключительную) лицензию на использование " +
            "Ресурса и размещенного на сайте контента на условиях, изложенных в настоящем Соглашении.<br />2.2. Администрация Ресурса подтверждает, что обладает " +
            "всеми исключительными правами в отношении сайта.<br />2.3. Предметом Соглашения является порядок использования Ресурса Mizaem.ru, в том числе порядок " +
            "использования и размещения на нем информации Пользователями.<br /><br /><strong>3. Регистрация учетной записи</strong><br />3.1. Для регистрации учетной " +
            "записи Пользователь обязан указать свои достоверные и актуальные данные, а также логин и пароль в соответствующих полях формы, размещенной на Ресурсе.<br />" +
            "3.2. Пользователь несет персональную ответственность за безопасность и устойчивость к взлому третьими лицами выбранного Пользователем пароля, а также " +
            "самостоятельно обеспечивает его конфиденциальность. Пользователь обязуется не сообщать третьим лицам логин и пароль, указанные при регистрации.<br />" +
            "3.3. Пользователь подтверждает, что любые действия, совершенные под его учетной записью, включая (без ограничений) нажатие кнопок подтверждения согласия " +
            "с любыми соглашениями и правилами, будут расцениваться как санкционированные самим Пользователем, если не доказано обратное.<br />3.4. Администрация сайта " +
            "оставляет за собой право устанавливать процедуру подтверждения регистрации учетной записи и вводить требования к логину и паролю Пользователя в целях " +
            "обеспечения безопасности учетной записи. Также Администрация Ресурса оставляет за собой право не предоставлять Пользователю доступ в личный кабинет и " +
            "(или) заблокировать доступ к личному кабинету.<br />3.5. В случае, если Пользователю станет известно о любом несанкционированном использовании реквизитов " +
            "личного аккаунта, следует незамедлительно уведомить об этом Администрацию сайта, выслав соответствующее электронное сообщение на адрес wg-aloha@ya.ru." +
            "<br /><br /><strong>4. Условия использования сайта</strong><br />4.1. Пользователь обязуется не воспроизводить, не повторять и не копировать, не продавать " +
            "и не перепродавать, а также не использовать для каких-либо коммерческих целей какие-либо части Ресурса mizaem.com.kz, кроме тех случаев, когда такое " +
            "разрешение письменно дано Пользователю Администрацией.<br />4.2. Пользователь вправе прекратить пользоваться Ресурсом и удалить свою учетную запись в " +
            "любой момент.&nbsp;&nbsp;&nbsp;<br /><br /><strong>5. Персональные данные</strong><br />5.1. Размещая персональные и иные данные и сведения на Ресурсе " +
            "mizaem.com.kz Пользователь дает согласие на использование их для оказания услуг и предоставления возможности использования Ресурса. Также он соглашается " +
            "на применение персональных данных Ресурсом для предоставления рекламы, проведения статистических исследований и анализа полученных данных, информирования " +
            "о новых предложениях и продуктах информационно-рекламного свойства с помощью электронных средств связи (которые укажет Пользователь) и осуществления иных " +
            "действий. Помимо этого Пользователь дает согласие на передачу третьим лицам персональных и иных данных, в том числе для целей их обработки, для обеспечения" +
            " функционирования Ресурса, реализации партнерских и иных программ, при условии обеспечения администрацией Ресурса mizaem.com.kz в отношении передаваемых " +
            "Пользователем данных режима, который аналогичен существующему на указанном Ресурсе.<br /><br /><strong>6. Ответственность</strong><br />6.1. В отношении " +
            "текстовых материалов (статей, публикаций, находящихся в свободном публичном доступе на Ресурсе) допускается их распространение при условии, что будет " +
            "дана активная ссылка на сайт mizaem.com.kz<br />6.2. Все логотипы, имена брендов &nbsp;и зарегистрированные торговые марки, перечисленные на страницах" +
            " Ресурса, принадлежат их правообладателям.<br />6.3. Администрация Ресурса не несет ответственности за любые прямые или косвенные убытки, произошедшие " +
            "из-за: использования, либо невозможности использования Ресурса или его отдельных сервисов; несанкционированного доступа к коммуникациям Пользователя; " +
            "заявлений или действий любого третьего лица на Ресурсе.<br />6.4. Положения настоящего Соглашения не исключают и не ограничивают ответственность " +
            "Администрации сайта за причинение убытков в той степени, в которой такая ответственность не может быть исключена или ее действие не может быть " +
            "ограничено российским законодательством.<br />6.5. Администрация Ресурса не несет ответственности за какую-либо информацию, сведения или иной контент," +
            " размещенные Пользователем на Ресурсе, включая, но не ограничиваясь, информацией, защищенной авторским правом без прямого согласия владельца авторского " +
            "права.<br /><br /><strong>7. Заключительные положения</strong><br />7.1. Ничто в Соглашении не может пониматься как установление между Пользователем и " +
            "Администрацией сайта агентских отношений, отношений товарищества, отношений по совместной деятельности, трудовых отношений, либо каких-то иных отношений, " +
            "прямо не предусмотренных Соглашением.<br />7.2. Если по тем или иным причинам одна или несколько норм настоящего Соглашения являются недействительными " +
            "или не имеющими юридической силы, это не оказывает влияния на действительность или применимость остальных норм.<br />7.3. Названия разделов настоящего " +
            "Соглашения устанавливаются исключительно в справочных целях и никаким образом не определяют, не ограничивают и не толкуют содержание соответствующего " +
            "раздела.<br />7.4. К настоящему Соглашению применяется законодательство республики Казахстан.<br />7.5. Соглашение-оферта вступает в силу с момента " +
            "согласия Пользователя с условиями настоящего Соглашения (в момент создания учетной записи, аккаунта, написания комментария, взаимодействия), срок " +
            "действия которого не ограничен данным Соглашением-офертой.<br />7.6. Администрация сайта оставляет за собой право вносить изменения в настоящее " +
            "Соглашение. Изменения вступают в силу с момента их публикации на Ресурсе. Настоящим Пользователь признает и соглашается, что использование им Ресурса " +
            'после внесения изменений в настоящее Соглашение автоматически означает согласие Пользователя с внесенными изменениями.</span></p><p style="text-align: right;">' +
            '<span style="font-size:16px;">С уважением, Администрация сайта </span>',
        offer_terms:
            '<span style="font-size:18px;">Основные положения</span></strong></span></p>' +
            '<p style="font-size: 17px; line-height: 1.45; margin-top: 18px; color: rgb(0, 0, 0); font-family: " open="" sans="">' +
            '<span style="font-style:normal;font-weight:400;font-size:16px;">Порядок обработки персональных сведений физлиц компанией ООО ' +
            "&laquo;КЛЕВЕР&raquo; (далее &ndash; Компания) в полной мере отвечает всем нормам действующего законодательства Республики Казахстан. " +
            "Политика Компании (дальше &ndash;&nbsp;Политика) направлена на защиту прав граждан на тайну личной жизни и конфиденциальность личных " +
            'данных.</span></p><p style="font-size: 17px; line-height: 1.45; margin-top: 18px; color: rgb(0, 0, 0); font-family: " open="" sans="">' +
            '<span style="font-style:normal;font-weight:400;font-size:16px;">Положения, размещенные на данной странице, касаются обработки Компанией ' +
            "всех данных, которые предоставляют физлица в ходе регистрации на сайте и использования ее услуг. Компания и все ее подразделения несут " +
            "ответственность за соблюдение норм Политики.</span></p>" +
            '<p style="font-size: 17px; line-height: 1.45; margin-top: 18px; color: rgb(0, 0, 0); font-family: " open="" sans="">' +
            '<span style="font-size:18px;"><span f_id="open_sans_normal" f_uid="16" style="font-family:open sans;font-style:normal;font-weight:400;">' +
            "<strong>Определения</strong></span></span></p>" +
            '<p style="font-size: 17px; line-height: 1.45; margin-top: 18px; color: rgb(0, 0, 0); font-family: " open="" sans="">' +
            '<span style="font-style:normal;font-weight:400;font-size:16px;">Персональные сведения &ndash; информация, которая в ' +
            "какой-либо мере касается частной жизни и личности определенной физической особы. В число таких данных входит: ФИО, дата и " +
            "место рождения гражданина, его контакты, сведения о социальном и семейном положении, трудоустройстве и т.д.</span></p>" +
            '<p style="font-size: 17px; line-height: 1.45; margin-top: 18px; color: rgb(0, 0, 0); font-family: " open="" sans="">' +
            '<span style="font-style:normal;font-weight:400;font-size:16px;">Обработка персональных данных (далее &ndash;&nbsp;ОПД) &ndash; любые действия, ' +
            "которые совершает Компания с целью сбора, распространения и хранения сведений физлиц.</span></p>" +
            '<p style="font-size: 17px; line-height: 1.45; margin-top: 18px; color: rgb(0, 0, 0); font-family: " open="" sans="">' +
            '<span f_id="open_sans_normal" f_uid="16" style="font-family:open sans;font-style:normal;font-weight:400;">' +
            '<span style="font-size:18px;"><strong>Условия и принципы ОПД</strong></span></span></p>' +
            '<p style="font-size: 17px; line-height: 1.45; margin-top: 18px; color: rgb(0, 0, 0); font-family: " open="" sans="">' +
            '<span style="font-style:normal;font-weight:400;font-size:16px;">Согласно данной Политике, Компания может обрабатывать ' +
            'данные лиц, которые являются:</span></p><span style="font-style:normal;font-weight:400;font-size:16px;">клиентами ' +
            "Компании;сотрудниками Компании;претендентами на замещение должностей в штате Компании;особами, прошедшими регистрацию " +
            "на сайте Компании;представителями юрлиц, сотрудничающих с Компанией.</span>" +
            '<p style="font-size: 17px; line-height: 1.45; margin-top: 18px; color: rgb(0, 0, 0); font-family: " open="" sans="">' +
            '<span style="font-style:normal;font-weight:400;font-size:16px;">Компания обязуется обеспечивать защиту данных указанных ' +
            "категорий лиц от любого неправомерного использования.</span></p>" +
            '<p style="font-size: 17px; line-height: 1.45; margin-top: 18px; color: rgb(0, 0, 0); font-family: " open="" sans="">' +
            '<span style="font-style:normal;font-weight:400;font-size:16px;">Принципами, на которых основывается ОПД Компании, является: ' +
            "законность и справедливость. Все методы и цели использования сведений физлиц не могут иди вразрез действующему законодательству " +
            "Республики Казахстан, либо в какой-либо мере нарушать права и свободы граждан.</span></p>" +
            '<p style="font-size: 17px; line-height: 1.45; margin-top: 18px; color: rgb(0, 0, 0); font-family: " open="" sans="">' +
            '<span style="font-style:normal;font-weight:400;font-size:16px;">Выполнять ОПД Компания вправе только при условии, что это ' +
            "оправдано ее функциями, а также при наличии согласия владельца сведений. Компания оставляет за собой право использовать " +
            "персональную информацию граждан, если это необходимо для защиты ее прав, а также в других целях, которые не перечат " +
            "законодательству Республики Казахстана.</span></p>" +
            '<p style="font-size: 17px; line-height: 1.45; margin-top: 18px; color: rgb(0, 0, 0); font-family: " open="" sans="">' +
            '<span style="font-style:normal;font-weight:400;font-size:16px;">Политика также дает Компании право доверять осуществление ' +
            "ОПД третьим лицам в порядке, который определяет законодательство Республики Казахстан.</span></p>" +
            '<p style="font-size: 17px; line-height: 1.45; margin-top: 18px; color: rgb(0, 0, 0); font-family: " open="" sans="">' +
            '<span style="font-size:18px;"><span f_id="open_sans_normal" f_uid="16" style="font-family:open sans;font-style:normal;font-weight:400;">' +
            "<strong>Права владельцев личных данных</strong></span></span></p>" +
            '<p style="font-size: 17px; line-height: 1.45; margin-top: 18px; color: rgb(0, 0, 0); font-family: " open="" sans="">' +
            '<span style="font-style:normal;font-weight:400;font-size:16px;">Лица, сведения которых обрабатывает Компания, вправе ' +
            "запрашивать официальное подтверждение факта использования своих личных данных. Они также могут требовать информацию о:</span></p>" +
            '<span style="font-style:normal;font-weight:400;font-size:16px;">целях и методах ОПД;действующем адресе и контактах Компании либо ее ' +
            "подразделений;лицах, у которых есть право совершать ОПД;факте передачи третьим лицам полномочий на осуществление ОПД.</span>" +
            '<p style="font-size: 17px; line-height: 1.45; margin-top: 18px; color: rgb(0, 0, 0); font-family: " open="" sans="">' +
            '<span style="font-style:normal;font-weight:400;font-size:16px;">У физлиц есть право в любой момент отменить свое согласие на ОПД в ' +
            "одностороннем порядке, также требовать блокировки/уничтожения всех обрабатываемых сведений, если последние получены незаконным путем " +
            "либо являются ошибочными. Они также могут обратиться в суд, если действия Компании в процессе ОПД нарушили их права и свободы.</span>" +
            '</p><p style="font-size: 17px; line-height: 1.45; margin-top: 18px; color: rgb(0, 0, 0); font-family: " open="" sans="">' +
            '<span f_id="open_sans_normal" f_uid="16" style="font-family:open sans;font-style:normal;font-weight:400;"><strong>' +
            '<span style="font-size:18px;">Ответственность</span></strong></span></p>' +
            '<p style="font-size: 17px; line-height: 1.45; margin-top: 18px; color: rgb(0, 0, 0); font-family: " open="" sans="">' +
            '<span style="font-style:normal;font-weight:400;font-size:16px;">Ответственность Компании за нарушение норм действующей ' +
            "Политики определяется законодательством Республики Казахстан.</span>",
        click_here_if_already_registered: "Нажмите здесь, если уже зарегистрированы",
    },
};
export default translations;
